import { useState, useCallback, useMemo } from "react";
import { useUserContext } from "../use-auth-context";
import { useMultiSiteContext } from "../use-site-context";
import { fetchWithTokenRefresh } from "@hooks/shared/fetch-with-token-refresh";

export const useSiteSettings = () => {
  const [siteSettings, setSiteSettings] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { user } = useUserContext();
  const { getApiUrl } = useMultiSiteContext();
  const apiUrl = useMemo(
    () => getApiUrl("wp-json/wp/v2/settings"),
    [getApiUrl]
  );

  const getSiteSettings = useCallback(() => {
    if (!user?.canManageOptions) {
      return Promise.resolve(null);
    }
    setLoading(true);
    return fetchWithTokenRefresh(
      apiUrl,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.authToken ?? ""}`,
        },
      },
      null
    )
      .then((response) => {
        if (!response.ok) {
          // 403 means the user lacks permission — non-fatal, skip silently
          setLoading(false);
          return null;
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          setSiteSettings(data);
        }
        setLoading(false);
        return data;
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [apiUrl, user?.authToken, user?.canManageOptions]);

  return { getSiteSettings, siteSettings, loading, error };
};
